import HeatIcon from './component'

export default HeatIcon
